import {
  CabinetConfigurationState,
  StoreConstants,
  ConfigurationChangeModel,
  CabinetConfigurationSettingsModel
} from '@/types';
import { MutationTree } from 'vuex';

export const mutations: MutationTree<CabinetConfigurationState> = {
  [StoreConstants.CabinetConfiguration.Mutations.SetCabinetConfigurationChange](
    state,
    cabinetConfigurationChange: ConfigurationChangeModel
  ) {
    state.cabinetConfigurationChange = cabinetConfigurationChange;
  },
  [StoreConstants.CabinetConfiguration.Mutations.SetIsLoading](state, isLoading: boolean) {
    state.isLoading = isLoading;
  },
  [StoreConstants.CabinetConfiguration.Mutations.SetCabinetConfigurationSettings](
    state,
    cabinetConfigurationSettings: CabinetConfigurationSettingsModel
  ) {
    state.cabinetConfigurationSettings = cabinetConfigurationSettings;
  },
  [StoreConstants.CabinetConfiguration.Mutations.SetCabinetConfigurationSettingsIsEncryptNewDocumentTypesEnabled](
    state,
    isEncryptNewDocumentTypesEnabled: boolean
  ) {
    state.cabinetConfigurationSettings.isEncryptNewDocumentTypesEnabled = isEncryptNewDocumentTypesEnabled;
  }
};
